import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=4f1692bc&scoped=true"
import script from "./PersonCenter.vue?vue&type=script&lang=js"
export * from "./PersonCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonCenter.vue?vue&type=style&index=0&id=4f1692bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1692bc",
  null
  
)

export default component.exports